<template>
    <div class="root flex wrap center vcenter">
        <div class="item flex wrap center vcenter">
            <MetaBox :meta="{
                key: 'nid',
                type: 'nid',
                name: 'کد یا شناسه ملی / اتباع'
            }" :vm="models['nid'] || ''" @onchange="onchange"></MetaBox>
        </div>
        <div class="item flex wrap center vcenter">
            <MetaBox :meta="{
                key: 'amount',
                type: 'amount',
                name: 'مبلغ سرمایه گذاری',
                extras: 'R0:key=min,value=10000000;R1:key=max,value=1000000000'
            }" :vm="models['amount'] || ''" @onchange="onchange"></MetaBox>
        </div>
        <div v-if="memorandum" class="accordion item flex wrap center vcenter">
            <Accordion :title="'مطالعه تفاهم نامه'" :description="memorandum.description" :default="'open'">
            </Accordion>
        </div>
        <div class="item flex wrap center vcenter">
            <Button :meta="{
                key: 'submit',
                name: 'پرداخت وجه'
            }" :active="loading" :disabled="disabled" @onclick="submit"></Button>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'

import Accordion from '../Form/Accordion.vue'
import Button from '../Form/Button.vue'

/* eslint-disable */
export default {
    name: 'Investments',
    props: ['data'],
    inject: ['base'],
    components: {
        MetaBox: defineAsyncComponent(() => import('../Form/Inputs/MetaBox.vue')),
        Accordion,
        Button
    },
    created() {
        this.base.API().get(`Privacy/Memorandum/GetRiskStatement`,
            (response) => {
                if (this.base.Util().success(response))
                    this.memorandum = response.data.data
            }, (error) => {
            })
    },
    data() {
        return {
            models: {},
            errors: {},
            memorandum: null,
            loading: false
        }
    },
    methods: {
        onchange(obj) {
            this.models[obj.key] = obj.value
            this.errors[obj.key] = obj.error
        },
        submit() {
            if (this.errors['nid'] || !this.base.Util().validate(this.models['nid'])) {
                this.base.Notification().error({
                    code: 1000,
                    text: 'کد یا شناسه ملی / اتباع'
                })
                return
            }

            if (this.errors['amount'] || !this.base.Util().validate(this.models['amount'])) {
                this.base.Notification().error({
                    code: 1000,
                    text: 'مبلغ سرمایه گذاری'
                })
                return
            }

            this.loading = true

            this.base.API().post(`Finance/Transaction/FastDeposit`, {
                data: [
                    {
                        fid: this.$route.params.id,
                        nid: this.models['nid'],
                        amount: Number(String(this.models['amount']).replaceAll(',', ''))
                    }
                ]
            }, (response) => {
                this.loading = false
                if (this.base.Util().success(response)) {
                    if (response.data.redirect) {
                        const form = document.createElement("form")
                        form.method = "POST"
                        if (response.data.data === 'SADAD') {
                            const input = document.createElement("input")
                            input.type = "hidden"
                            input.name = "Token"

                            const action = response.data.redirect.split('?Token=')
                            form.action = action[0]
                            input.value = action[1]
                            form.appendChild(input)
                        } else
                            form.action = response.data.redirect

                        document.body.appendChild(form)
                        form.submit()
                    } else
                        this.base.Notification().error({
                            code: 5000,
                            text: 'خطایی در هدایت به درگاه رخ داد، لطفا مجددا تلاش کنید!'
                        })
                }
                else
                    this.base.Notification().error({
                        code: response.data.errorCode,
                        referr: 'investments',
                        text: response.data.message
                    })
            }, (error) => {
                this.loading = false
                this.base.Notification().error({
                    code: 5000,
                    text: 'خطایی رخ داد، لطفا مجددا تلاش کنید!'
                })
            })
        }
    }
}
</script>

<style scoped src="../../assets/css/components/dialogs/investments.css"></style>